import { COMERCIAL_ADMIN_AREA_ACCESS_PERMISSIONS } from './comercialAdminPermissions';
import { PROPOSAL_BASE_ROUTE_PERMISSIONS } from './proposalBaseSheetPermissions';
const comercial = (acao) => ({ modulo: 'comercial', acao });
/** Permissões que liberam entrada em qualquer rota do módulo Comercial (/app/comercial/*). */
export const COMERCIAL_MODULE_ENTRY_PERMISSIONS = [
    comercial('visualizar'),
    comercial('criar'),
    comercial('editar'),
    comercial('configurar'),
    comercial('visualizar_so'),
    comercial('editar_so'),
    comercial('excluir_so'),
    comercial('visualizar_prioridades'),
    comercial('editar_prioridades'),
    comercial('excluir_prioridades'),
    comercial('visualizar_lista_prioridades'),
    comercial('editar_lista_prioridades'),
    comercial('excluir_lista_prioridades'),
    comercial('visualizar_central_propostas'),
    comercial('editar_central_propostas'),
    comercial('excluir_central_propostas'),
    comercial('visualizar_relatorios'),
    comercial('visualizar_eneel'),
    comercial('visualizar_anp_etanol'),
    comercial('visualizar_custo'),
    comercial('editar_custo'),
    comercial('excluir_custo'),
    comercial('visualizar_setor'),
    comercial('editar_setor'),
    comercial('excluir_setor'),
    comercial('visualizar_dossie'),
    ...COMERCIAL_ADMIN_AREA_ACCESS_PERMISSIONS,
    ...PROPOSAL_BASE_ROUTE_PERMISSIONS,
];
